export default "__VITE_ASSET__UjgAaRi0__"